import { mutationOptions } from "@tanstack/react-query";

import { api } from "@platform/core/api";
import { queryClient } from "@platform/core/query";
import { apiKeysQueryOptions } from "./api-keys.queries";
import type { CreatedApiKey } from "./api-keys.types";

const invalidate = () => queryClient.invalidateQueries({ queryKey: apiKeysQueryOptions.queryKey });

export const createKeyMutation = mutationOptions({
	mutationFn: (vars: { name: string; ttlDays: number | null; scopes: string[] }) =>
		api.post<CreatedApiKey>("/platform/keys", vars),
	onSuccess: invalidate,
});

export const revokeKeyMutation = mutationOptions({
	mutationFn: (id: string) => api.post(`/platform/keys/${id}/revoke`),
	onSuccess: invalidate,
});
